import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import LEssenzaDelGusto from "./sections/LEssenzaDelGusto";
import DajamsApproach from "./sections/DajamsApproach";
import PartnersInProgress from "./sections/PartnersInProgress";
import KitchenInspirations from "./sections/KitchenInspirations";
import SikkimByTheNumbers from "./sections/SikkimByTheNumbers";
import RealFixesForRealNeighbors from "./sections/RealFixesForRealNeighbors";
import RejoignezLAventure from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <LEssenzaDelGusto />
      <DajamsApproach />
      <PartnersInProgress />
      {/* <KitchenInspirations /> */}
      {/* <SikkimByTheNumbers /> */}
      {/* <RealFixesForRealNeighbors /> */}
      <RejoignezLAventure />
    </div>;
}